import { render } from "./CreatePost.vue?vue&type=template&id=dda9eec4&ts=true"
import script from "./CreatePost.vue?vue&type=script&lang=ts"
export * from "./CreatePost.vue?vue&type=script&lang=ts"

import "./CreatePost.vue?vue&type=style&index=0&id=dda9eec4&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__